import { render, staticRenderFns } from "./TestPass.vue?vue&type=template&id=fa522d42&scoped=true"
import script from "./TestPass.vue?vue&type=script&lang=js"
export * from "./TestPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa522d42",
  null
  
)

export default component.exports